import module0 from '@ice/plugin-store/runtime';
                import module1 from '@ice/plugin-auth/runtime';
                import module2 from '@ice/plugin-request/runtime';
                
export const statics = [
  module2,
];
export const commons = [
  module0,
  module1,
];
